import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pipeline.css';

export const PIPELINE_STAGES = [
  { id: 'requirements', label: 'Requirements', icon: '📋' },
  { id: 'design',        label: 'Design',        icon: '🏛️' },
  { id: 'docs',          label: 'Docs',           icon: '📚' },
  { id: 'code',          label: 'Code',           icon: '💻' },
  { id: 'tests',         label: 'Tests',          icon: '🧪' },
  { id: 'cicd',          label: 'CI/CD',          icon: '🔁' },
  { id: 'deployment',    label: 'Deploy',         icon: '🚀' },
];

/**
 * PipelineNav – horizontal stepper.
 * Completed stages show a green tick. Current stage is highlighted blue.
 * Future stages are dimmed (but still clickable so users can jump back).
 */
function PipelineNav({ project, currentStageId }) {
  const navigate = useNavigate();

  const currentIdx = PIPELINE_STAGES.findIndex((s) => s.id === currentStageId);

  const isCompleted = (stageId) => Boolean(project?.stages?.[stageId]?.approved);

  const canNavigate = (stageId, idx) => {
    // Can always go back; can only go forward if previous stage is approved
    if (idx <= currentIdx) return true;
    const prevId = PIPELINE_STAGES[idx - 1]?.id;
    return prevId ? isCompleted(prevId) : true;
  };

  return (
    <nav className="pipeline-stepper" aria-label="Pipeline stages">
      {PIPELINE_STAGES.map((stage, idx) => {
        const done = isCompleted(stage.id);
        const active = stage.id === currentStageId;
        const enabled = canNavigate(stage.id, idx);

        return (
          <div className="pipeline-step" key={stage.id}>
            {idx > 0 && <div className="pipeline-step-connector" />}
            <button
              className={`pipeline-step-btn${active ? ' active' : ''}${done ? ' completed' : ''}`}
              disabled={!enabled}
              onClick={() => navigate(`/tools/pipeline/${stage.id}`)}
              aria-current={active ? 'step' : undefined}
            >
              <span className="pipeline-step-icon">{stage.icon}</span>
              {stage.label}
              {done && !active && (
                <span className="pipeline-step-check" aria-label="completed">✓</span>
              )}
            </button>
          </div>
        );
      })}
    </nav>
  );
}

export default PipelineNav;
